import { Grid2 as Grid } from '@mui/material'
import { FC, useContext } from 'react'
import AppContext from '../../../context/appContext'
import { isEligibilityEnabled } from '../../../utils/programConfig/areaSubtractions'
import { EligibilityCheckProvider } from '../EligibilityCheck/EligibilityCheckContext'
import { ExclusionAreaMap } from './ExclusionAreaMap'
import { ExclusionAreaPanel } from './ExclusionAreaPanel/ExclusionAreaPanel'

export const ExclusionAreaHome: FC = () => {
  const { programConfig } = useContext(AppContext)
  const eligibilityEnabled = isEligibilityEnabled(programConfig)

  const content = (
    <Grid container width="100%">
      <Grid size={{ xs: 8, md: 6, lg: 4 }}>
        <ExclusionAreaPanel />
      </Grid>
      <Grid size={{ xs: 4, md: 6, lg: 8 }}>
        <ExclusionAreaMap />
      </Grid>
    </Grid>
  )

  return eligibilityEnabled ? (
    <EligibilityCheckProvider>{content}</EligibilityCheckProvider>
  ) : (
    content
  )
}
